import { isAuthenticated, isAuthorized } from 'Helpers'
import { Redirect, Route } from 'react-router-dom'

const PrivateRoute = ({ component: Component, ...rest }) => {
  const routes = { ...rest }
  return (
    <Route
      {...rest}
      render={(props) =>
        !isAuthenticated() ? (
          <Redirect to="/" />
        ) : isAuthorized(routes.path) ? (
          <Component {...props} />
        ) : (
          <Redirect to="/home" />
        )
      }
    />
  )
}

export default PrivateRoute
